<template>
    <span>
        <template v-if="person.firstname || person.lastname">
            {{ person.firstname }} {{ person.lastname }}
        </template>
        <template v-else-if="person.email">
            {{ person.email }}
        </template>
        <template v-else-if="person.phone">
            {{ person.phone }}
        </template>
        <template v-else-if="registeringPersonType === 'participant'">
            <template v-if="changeWordingRegistrationBuy">
                {{ $t('eventRegistration.participant.personNumber') }}{{ index + 1 }}
            </template>
            <template v-else-if="isCaregiver">
                {{ $t('eventRegistration.participant.caregiverNumber') }}{{ index + 1 }}
            </template>
            <template v-else>
                {{ $t('eventRegistration.participant.participantNumber') }}{{ index + 1 }}
            </template>
        </template>
        <template v-else-if="registeringPersonType === 'invoiceRecipient'">
            {{ $t('eventRegistration.participant.noName') }}
        </template>
    </span>
</template>

<script>
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";
import registrationCaregiverMixin from "@/mixins/registration/registrationCaregiverMixin";

export default {
    name: "PersonName",
    mixins: [registrationOnlineRegistrationFieldsMixin, registrationCaregiverMixin],
    props: {
        person: {
            type: Object,
            default: () => {
                return {}
            }
        },
        index: {
            type: Number
        },
        registeringPersonType: {
            type: String,
            default: 'participant'
        }
    }
}
</script>

<style scoped>

</style>
